/* eslint-disable @calm/react-intl/missing-formatted-message */
import Restart16 from '@carbon/icons-react/es/restart/16';
import Intercom, { show } from '@intercom/messenger-js-sdk';
import { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { ReactComponent as ExclamationTriangle } from 'assets/svgs/exclamation-triangle.svg';
import { EmptyState, EmptyStateContainer } from 'components/atoms/empty-state';
import { Button } from 'components/facade/button';
import { BodyShort01 } from 'components/styles';
import { INTERCOM_APP_ID } from 'config/environment';
import { useTranslate } from 'hooks/use-translation';

const Description = styled.div`
  ${BodyShort01};
`;

const RefreshButton = styled(Button)`
  width: fit-content;
`;

const LinkButton = styled(Button)`
  padding: 0 var(--spacing-01) !important;
`;

enum Status {
  Unchecked = 'Unchecked',
  NotRequired = 'NotRequired',
  Loaded = 'Loaded',
  Initialized = 'Initialized',
}

let status: Status = Status.Unchecked;

const initIntercomChat = () => {
  if (status !== Status.Loaded) {
    return;
  }
  status = Status.Initialized;

  Intercom({
    app_id: INTERCOM_APP_ID ?? '',
    alignment: 'left',
    horizontal_padding: 70,
    vertical_padding: 35,
    hide_default_launcher: true,
  });
};
const initialize = () => {
  if (status !== Status.Unchecked) {
    return;
  }
  status = Status.Loaded;
  initIntercomChat();
};

export const AppCrashIntercom = () => {
  const translate = useTranslate();

  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  const openIntercomChat = useCallback(() => {
    show();
  }, []);

  useEffect(() => {
    if (status === Status.Unchecked) {
      initialize();
      status = Status.NotRequired;
    }
  }, []);

  return (
    <EmptyStateContainer $transparent>
      <EmptyState
        image={<ExclamationTriangle />}
        title={translate('document.open.version.failure.title')}
        message={translate('document.open.version.failure.message.text')}
        primaryCTA={
          <RefreshButton
            type="primary"
            onClick={refreshPage}
            iconPlacement="right"
            icon={<Restart16 />}
          >
            Refresh
          </RefreshButton>
        }
        secondaryCTA={
          <Description>
            If the issue still persists
            <LinkButton type="link" onClick={openIntercomChat}>
              please reach out to us.
            </LinkButton>
          </Description>
        }
      />
    </EmptyStateContainer>
  );
};
